import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import AppPageTemplate from '@/components/templates/AppPageTemplate';
import { useAppStore } from '@/store/useAppStore';
import { getUnacceptedContentPolicy, isEverythingSetup } from '@/utils/onboardingUtils';

const CreatorLayout = () => {
  return (
    <AppPageTemplate>
      <Outlet />
    </AppPageTemplate>
  );
};

export const Route = createFileRoute('/_authenticated/_creator')({
  component: CreatorLayout,
  beforeLoad: async ({ context: { auth }, location }) => {
    const isOrgAdmin = auth?.isAdmin;
    const isSuperAdmin = auth?.isSuperAdmin;
    const isContentCreator = auth?.isContentCreator;
    const isContentCreatorOnly = isContentCreator && auth?.user?.roles.length === 1;
    // Applicants who have submitted but are not yet approved are allowed onto the creator
    // profile — it is where the apply flow lands them, and it degrades for a pending
    // applicant. The rest of the creator area stays role-gated.
    const isCreatorProfile = location.pathname === '/creator/profile';

    const { onboardingStatuses, hasUnacceptedLegalDocuments, legalAcceptanceStatuses } = useAppStore.getState();
    const pendingContentPolicy = getUnacceptedContentPolicy(legalAcceptanceStatuses);

    if (!isSuperAdmin && isContentCreator && pendingContentPolicy) {
      throw redirect({
        to: '/creator/apply/content-policy',
      });
    }

    const isOnboardingCompleted = isEverythingSetup(onboardingStatuses, isOrgAdmin, isContentCreatorOnly);

    if (!isOnboardingCompleted && !isSuperAdmin) {
      const { isOrganizationOnboardingCompleted, isUserOnboardingCompleted } = onboardingStatuses;
      if (isOrgAdmin && !isOrganizationOnboardingCompleted) {
        throw redirect({
          to: '/onboarding/organization',
        });
      }

      if (!isUserOnboardingCompleted) {
        throw redirect({
          to: '/onboarding/user',
        });
      }
    }

    if (hasUnacceptedLegalDocuments && !isSuperAdmin) {
      if (isContentCreator && pendingContentPolicy) {
        throw redirect({
          to: '/creator/apply/content-policy',
        });
      }

      throw redirect({
        to: '/eula/update',
      });
    }

    if (!isContentCreator && !isSuperAdmin && !isCreatorProfile) {
      throw redirect({
        to: '/user/dashboard',
      });
    }
  },
});
